export default __webpack_public_path__ + "static/media/apr-icon.0193615d.svg";